import {createRouter, createWebHistory} from 'vue-router';


import Login from '#views/auth/login';
import ChangePassword from '#views/auth/change_password';

import ServicesStore from '#views/service/store';
import ServicesInbox from '#views/service/inbox';
import ServicesOutbox from '#views/service/outbox';
import ServicesExecution from '#views/service/execution';
import MultipleExecution from '#views/service/execution/multiple';
import ServicesGroup from '#views/service/groups';

import SourceServicesIndex from '#views/service/source/list';
import SourceServicesShow from '#views/service/source/show';
import SourceServicesCategories from '#views/service/source/category';

import Organizations from '#views/organization/list';
import OrganizationsCategories from '#views/organization/categories';

import Collaborators from "#views/collaborator/list";
import CollaboratorsFunctions from '#views/collaborator/functions';

import PeopleIndex from '#views/person/list';
import PeopleShow from '#views/person/show';

import Users from '#views/settings/users/list';
import UserShow from '#views/settings/users/show';

import AccessProfile from '#views/settings/access_profile/list';
import EditPermissions from '#views/settings/access_profile/show';

import Dashboards from '#views/dashboard/index.vue';
import DashboardsShow from '#views/dashboard/show.vue';

import Functions from '#views/person/collaboration/index'

import MessageIndex from '../src/views/newsletter/message/list';

const routes = [
    {
        path: "/",
        name: "/",
        redirect: "/login",
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
            guest: true,
            name: 'Login'
        }
    },
    {
        path: '/change-password',
        name: 'ChangePassword',
        component: ChangePassword,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: false,
            name: 'Alteração de senha'
        }
    },
    {
        path: '/services-store',
        name: 'ServicesStore',
        component: ServicesStore,
        props: true,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Novo serviço'
        },
    },
    {
        path: '/services-inbox',
        name: 'ServicesInbox',
        component: ServicesInbox,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Caixa de entrada de serviços'
        },
    },
    {
        path: '/multiple-execution',
        name: 'MultipleExecution',
        component: MultipleExecution,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Execução de múltiplos serviços'
        },
    },
    {
        path: '/services-outbox',
        name: 'ServicesOutbox',
        component: ServicesOutbox,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Caixa de saída'
        }
    },
    {
        path: '/services/:service_id',
        name: 'ServicesExecution',
        component: ServicesExecution,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: false,
            name: 'Execução de Serviço'
        }
    },
    {
        path: '/services-group',
        name: 'ServicesGroup',
        component: ServicesGroup,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Serviços duplicados'
        },
        props: true,
    },
    {
        path: "/source-services",
        name: "SourceServicesIndex",
        component: SourceServicesIndex,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Serviços'
        }
    },
    {
        path: "/source-services/:id",
        name: "SourceServicesShow",
        component: SourceServicesShow,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Procedimentos de Serviço'
        },
    },
    {
        path: "/source-services-categories",
        name: "SourceServicesCategories",
        component: SourceServicesCategories,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Categorias dos Serviços'
        }
    },
    {
        path: "/organizations",
        name: "Organizations",
        component: Organizations,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Organizações'
        }
    },
    {
        path: "/organizations-categories",
        name: "OrganizationsCategories",
        component: OrganizationsCategories,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Categoria das Organizações'
        }
    },
    {
        path: "/collaborators",
        name: "Collaborators",
        component: Collaborators,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Colaboradores'
        }
    },
    {
        path: "/collaborators-functions",
        name: "CollaboratorsFunctions",
        component: CollaboratorsFunctions,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Funções dos Colaboradores'
        }
    },
    {
        path: '/people',
        name: 'PeopleIndex',
        component: PeopleIndex,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Pessoas'
        },
    },
    {
        path: '/people/:id',
        name: 'PeopleShow',
        component: PeopleShow,
        props: true,
        children: [
            {
                path: 'functions',
                name: 'Functions',
                component: Functions,
                meta: {
                    requiresAuth: true,
                    requiresChangedPassword: true,
                    name: 'Funções'
                },
            }
        ],
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Pessoa'
        }
    },
    {
        path: '/users',
        name: 'Users',
        component: Users,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Usuários'
        },
    },
    {
        path: '/users/:id',
        name: 'UserShow',
        component: UserShow,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Usuário'
        },
    },
    {
        path: '/configs/access-profile',
        name: 'AccessProfile',
        component: AccessProfile,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Perfis de acesso'
        }
    },
    {
        path: '/configs/access-profile/:id',
        name: 'EditPermissions',
        component: EditPermissions,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Editar perfil de acesso'
        }
    },
    {
        path: '/dashboards',
        name: 'Dashboards',
        component: Dashboards,
        props: true,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Dashboards'
        },
    },
    {
        path: '/dashboards/:dashboard_id',
        name: 'DashboardsShow',
        component: DashboardsShow,
        props: true,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            name: 'Dashboard'
        },
    },
    {
        path: '/newsletter/message',
        name: 'MessageIndex',
        component: MessageIndex,
        meta: {
            requiresAuth: true,
            requiresChangedPassword: true,
            permission: 'newsletter.messages.index',
            name: 'Mensagens'
        }
    },

];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    linkActiveClass: "active",
    mode: 'history',
    routes
});

export default router;